module.exports = __webpack_public_path__ + "img/goto-logo.1ed1c2cc.svg";